// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3fl6h","selects":"Documents_selects__2PxYR"};